"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * PNS Client API
 * PNS - Push Notification Service: Api per l\'invio di notifiche
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserMessagesApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class UserMessagesApi extends runtime.BaseAPI {
    /**
     * Restituisce la lista degli ultimi messaggi inviati ad un utente
     * Lista dei messaggi
     */
    userMessagesGetRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/private/messages`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Restituisce la lista degli ultimi messaggi inviati ad un utente
     * Lista dei messaggi
     */
    userMessagesGet() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.userMessagesGetRaw();
            return yield response.value();
        });
    }
    /**
     * Chiamata per aggiornare lo stato di un messaggio ricevuto Al momento viene solo settatto a true il flag isLetto del messaggio
     * Aggiorna lo stato di un messaggio
     */
    userMessagesPutRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.updateMessageData === null || requestParameters.updateMessageData === undefined) {
                throw new runtime.RequiredError('updateMessageData', 'Required parameter requestParameters.updateMessageData was null or undefined when calling userMessagesPut.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/private/messages`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.UpdateMessageDataToJSON(requestParameters.updateMessageData),
            });
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Chiamata per aggiornare lo stato di un messaggio ricevuto Al momento viene solo settatto a true il flag isLetto del messaggio
     * Aggiorna lo stato di un messaggio
     */
    userMessagesPut(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.userMessagesPutRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.UserMessagesApi = UserMessagesApi;
